import { render, staticRenderFns } from "./TravelDeclarationReport.vue?vue&type=template&id=48d41807&scoped=true"
import script from "./TravelDeclarationReport.vue?vue&type=script&lang=js"
export * from "./TravelDeclarationReport.vue?vue&type=script&lang=js"
import style1 from "./TravelDeclarationReport.vue?vue&type=style&index=1&id=48d41807&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d41807",
  null
  
)

export default component.exports